import { calComLinkFI, calComLinkSE } from "../constants";
import { CountryCode } from "../types/common";

// Do NOT switch to Cal.com's `/embed` to drop the toolbar: that page waits on
// `@calcom/embed-core`'s postMessage handshake before it paints, so in a plain
// iframe it stays blank and nobody can book. Tried, reverted.
const BOOKING_URL_BY_COUNTRY: Readonly<Record<CountryCode, string>> = {
  [CountryCode.SE]: calComLinkSE,
  [CountryCode.FI]: calComLinkFI,
};

export const resolveWidgetBookingUrl = (countryCode: CountryCode): string =>
  BOOKING_URL_BY_COUNTRY[countryCode];
